import React, {useContext} from "react";
import fichaPdf from './fichaPdf'
import { makeStyles } from "@material-ui/core/styles";
import { UserContext } from 'context/userContext'
import { PDFDownloadLink } from '@react-pdf/renderer';

const styles = {
  loading:{
    textAlign: 'center',
    fontSize: 11,
    color: 'rgb(50, 50, 50)',
  },
}

const useStyles = makeStyles(styles);

function FichaDownloadLink (props){
  const classes = useStyles();
  const {userOptions, userProfile} = useContext(UserContext)

  return (
        <PDFDownloadLink document={fichaPdf({...userProfile, ...userOptions, ...props.ficha})}
                         key={Math.random()}
                         fileName={`APA ${props.ficha.nome}.pdf`}>
          {({ blob, url, loading, error }) => (loading ? (<p className={classes.loading}>CARREGANDO...</p>)
                                                        :
                                                         <>{props.link}</>

          )}
        </PDFDownloadLink>
    )
}

export default FichaDownloadLink;
